<template>
  <div
    class="content-category-header"
    :class="{ 'active-category': activeCategory }"
  >
    <div class="content-category-header-itens">
      <div class="div-category d-none d-lg-flex">
        <button
          class="div-category-btn-close"
          @click="setActiveCategory(false)"
        >
          <img
            class="img-fluid"
            src="@/assets/img/icons/close.png"
            alt="icon close"
            title="icon close"
          />
        </button>
      </div>
      <div
        class="div-category-content"
        v-for="(category, indexCat, index) in categories"
        :key="index"
      >
        <div class="div-category-content-title">
          <h2>{{ indexCat }}</h2>
          <div class="div-category d-lg-none">
            <button
              class="div-category-btn-close"
              @click="setActiveCategory(false)"
            >
              <img
                class="img-fluid"
                src="@/assets/img/icons/close.png"
                alt="icon close"
                title="icon close"
              />
            </button>
          </div>
        </div>
        <div class="div-category-content-list">
          <div class="div-category-content-list-item">
            <div class="accordion" role="tablist">
              <div class="accordion-div" v-for="(cat, i) in category" :key="i">
                <button
                  class="accordion-div-btn"
                  v-b-toggle="`accordion-${i}`"
                  role="tab"
                >
                  <p>{{ cat.name }}</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13.346"
                    height="23.691"
                    viewBox="0 0 13.346 23.691"
                  >
                    <g transform="translate(22.191 11.846) rotate(135)">
                      <path
                        d="M20.691,0,10.346,10.346ZM0,0,10.346,10.346Z"
                        transform="translate(0 14.631) rotate(-45)"
                        fill="#338545"
                        stroke="#338545"
                        stroke-linejoin="round"
                        stroke-width="3"
                      />
                    </g>
                  </svg>
                </button>
                <b-collapse
                  class="accordion-div-collapse"
                  :id="`accordion-${i}`"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <a
                    class="accordion-div-collapse-btn"
                    @click="sendFamily(cat)"
                  >
                    <strong>{{ $t('pages.product.seeall')}} {{ cat.name }}</strong>
                  </a>
                  <a
                    class="accordion-div-collapse-btn"
                    v-for="(subCategory, indexSubCategory) in cat.subfamilies"
                    :key="indexSubCategory"
                    @click="sendFilter(subCategory.slug, cat.slug)"
                  >
                    {{ subCategory.name }}
                  </a>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: ["categories", "slug"],
  computed: {
    ...mapGetters(["activeCategory"]),
  },
  methods: {
    ...mapActions({
      setActiveCart: "setActiveCart",
    }),
    ...mapActions({
      setActiveCategory: "setActiveCategory",
    }),

    sendFamily(family) {
      this.$store.dispatch("Products/FilterStore/setFilterList", {
        family: family.slug
      });
      this.$store.dispatch("Products/getProductsFiltered", {
        family: family.slug,
      })
      this.$router
        .push({ name: "CategoriesStore", 
          params: {
            slug: this.slug,
            family: family.slug,
          },
        })
        .catch(() => {});

      this.setActiveCategory(false);

    },

    sendFilter(subfamily, family) {
      this.$store.dispatch("Products/FilterStore/setFilterList", {
        subfamily: subfamily,
      });

      this.setActiveCategory(false);
      this.$router
        .push({ name: "CategoriesStore", 
          params: {
            slug: this.slug,
            family: family,
          },
        })
        .catch(() => {});
    },
  }
};
</script>

<style lang="scss">
.content-category-header {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  max-width: 570px;
  background: transparent;
  display: flex !important;
  z-index: 1001;
  height: 100%;
  transform: translateX(-100%);
  transition: 800ms ease-in-out;
  @media (max-width: 991px) {
    width: 90%;
  }
  @media (max-width: 359px) {
    width: 100%;
  }
  &-itens {
    height: 100%;
    width: 100%;
    padding: 75px 30px !important;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    background-color: var(--white);
    overflow-y: auto;
    @media (max-width: 991px) {
      width: 100%;
      flex-direction: row-reverse;
      padding: 25px 30px !important;
    }
    .div-category {
      height: 100%;
      margin-right: 30px;
      @media (max-width: 991px) {
        margin-right: 0;
      }
      &-btn-close {
        width: 62px;
        height: 53px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        padding: 1rem;
        text-decoration: none !important;
        border: 1px solid var(--green-medium);
        border-radius: 10px;
        background: var(--white);
        padding: 0;
        @media screen and (max-width: 991px) {
          width: 47px;
          height: 45px;
          max-width: 100%;
          align-items: center;
        }
        img {
          max-width: 24px;
        }
        p {
          font-size: 10px;
          color: var(--green-medium);
          font-family: "Font Light";
          text-align: center;
          margin-bottom: 0px;
        }
      }
    }
    .div-category-content {
      width: calc(100% - 92px);
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      height: 100%;
      width: 100%;
      &-title {
        width: 100%;
        border-bottom: 1px solid #b7b8b8;
        padding-bottom: 55px;
        margin-bottom: 17.5px;
        @media (max-width: 991px) {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 35px;
        }
        h2 {
          font-size: 30px;
          font-family: "Font Regular";
          color: var(--green-dark);
          margin-bottom: 0px;
          line-height: 1;
          text-align: left;
          @media (max-width: 991px) {
            font-size: 18px;
            width: calc(100% - 50px);
          }
        }
      }
      &-list {
        width: 100%;
        &-item {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .accordion {
            width: 100%;
            &-div {
              width: 100%;
              &-btn {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                text-decoration: none;
                margin-bottom: 0px;
                padding: 17.5px 0px;
                background: 0;
                border: 0;
                transition: 500ms;
                @media (min-width: 992px) {
                  &:hover {
                    opacity: 0.8;
                  }
                }
                p {
                  color: var(--green-medium);
                  font-family: "Font Regular";
                  font-size: 26px;
                  text-align: left;
                  width: calc(100% - 30px);
                  margin-bottom: 0;
                  transition: 500ms;
                  @media (max-width: 991px) {
                    font-size: 22px;
                  }
                  @media (max-width: 359px) {
                    font-size: 20px;
                  }
                }
                svg {
                  transform: rotate(-90deg);
                  margin-right: 10px;
                  transition: 500ms;
                  @media (max-width: 991px) {
                    max-width: 10px;
                  }
                }
                &[aria-expanded="true"] {
                  p {
                    color: var(--green-dark);
                  }
                  svg {
                    transform: rotate(90deg);
                  }
                }
              }
              &-collapse {
                &-btn {
                  cursor: pointer;
                  display: block;
                  width: 100%;
                  text-align: left;
                  background: 0;
                  border: 0;
                  font-size: 18px;
                  font-family: "Font Regular";
                  color: var(--gray-dark);
                  padding: 20px 0px;
                  transition: 500ms;
                  &:hover,
                  &:focus {
                    color: var(--green-dark);
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
.active-category {
  transform: translateX(0) !important;
  pointer-events: initial !important;
}
</style>